
import React, { useState } from 'react';
import emailjs from 'emailjs-com';

const Footer = () => {
const [popup, setPopup] = useState({
  show: false,
  title: '',
  message: ''
});
  const currentYear = new Date().getFullYear();

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email && !formData.phone) {
  setPopup({
    show: true,
    title: 'Contact Information Required',
    message: 'Please provide either your Email address or Mobile Number so we can contact you.'
  });
  return;
}

    setIsSubmitting(true);

    try {
      await emailjs.send(
        'service_gnods0t',
        'template_6pozsgp',
        formData,
        'Q8CPTd1VSMn4CQoNw'
      );

      setStatus('success');

      setFormData({
        name: '',
        email: '',
        phone: '',
        message: ''
      });
    } catch (error) {
      console.error(error);
      setStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="footer">
      <div className="container">

        <div className="footer-content">

          <div className="footer-main">
            <img
              src="/images/gayathri.png"
              alt="Ms. Gayathri D's Logo"
              className="footer-logo"
            />

            <h3>Ms. Gayathri D's SriChem Chemistry Tuition</h3>
            <p>M.Sc., M.Phil., B.Ed. | Specialized CBSE Chemistry Classes</p>
          </div>

          <div className="website-enquiry">
            <h3>Need a Website?</h3>

            <p>
              We build modern websites for businesses, tuition centres,
              portfolios and startups.
            </p>

            <form onSubmit={handleSubmit}>

              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <input
                type="email"
                name="email"
                placeholder="Email (optional)"
                value={formData.email}
                onChange={handleChange}
              />

              <input
                type="tel"
                name="phone"
                placeholder="Mobile Number (optional)"
                value={formData.phone}
                onChange={handleChange}
              />

              <textarea
                name="message"
                placeholder="Tell us about your website requirement..."
                rows="4"
                value={formData.message}
                onChange={handleChange}
              />

              <button
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Get a consultation'}
              </button>

            </form>

            {status === 'success' && (
              <p className="success-text">
                Thank you! We'll contact you shortly.
              </p>
            )}

            {status === 'error' && (
              <p className="error-text">
                Something went wrong. Please try again.
              </p>
            )}
          </div>

        </div>

        <div className="footer-bottom">
          <p>
            © {currentYear} SriChem Chemistry Tuition. All rights reserved.
          </p>
        </div>

      </div>
      {popup.show && (
  <div className="popup-overlay">
    <div className="popup-modal">
      <h3>{popup.title}</h3>
      <p>{popup.message}</p>

      <button
        onClick={() =>
          setPopup({
            show: false,
            title: '',
            message: ''
          })
        }
      >
        OK
      </button>
    </div>
  </div>
)}
    </footer>
  );
};

export default Footer;
